/**
 * The Tracking category decision, readable from outside React.
 *
 * Imports nothing, and must keep importing nothing: its readers are spread across the modules that
 * report events, and a dependency here would be one they all inherit — the shape that produces
 * import cycles between them.
 *
 * c15t owns the decision. This only mirrors it, so the mirror is never the thing to ask when React
 * is available.
 */

let trackingConsent = false;

/** Mirror c15t's Tracking decision. Called on every commit that changes it, so a revocation closes
 * the gate as soon as React has applied it. */
export function setTrackingConsent(granted: boolean) {
  trackingConsent = granted;
}

/** Whether the user has granted the Tracking category. */
export function isTrackingGranted() {
  return trackingConsent;
}
